import * as React from 'react';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import AuditReport from '../components/Admin/AdminReports/AuditReport';
function AdminAuditListingsPage() {
    return (
            <>
            <div className="parent-container">
            <div className="container">
                <div className="header-class">
                <Header isVisible={true} buttonsVisible={true} />
                </div>
            <div className="content-class">
                <AuditReport />
            </div>
            <div className="footer-class">
                <Footer />
            </div>
            </div>
      </div>
            </>
        );
}

export default AdminAuditListingsPage;